export default __webpack_public_path__ + "static/media/as-logo.79a9dbf6.svg";